import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { EMPTY } from "rxjs";
import { catchError, filter, switchMap, tap } from "rxjs/operators";
import { WalletService } from "src/app/services/wallet.service";

@Component({
  selector: 'app-ca-payment-loading',
  templateUrl: './ca-payment-loading.component.html'
})
export class CAPaymentLoadingComponent implements OnInit {
  message = "";
  constructor(
    private router: Router,
    private activateRoute: ActivatedRoute,
    private _service: WalletService,
    private _toast:ToastrService
  ) { }
  ngOnInit() {
    console.log("params ....")
    this.activateRoute.params
      .pipe(
        filter((x) => x.token),
        tap((va)=>console.log(va)),
        switchMap((x) => this.confirmPaymentRequest(x.txnRefNum, x.token))
      )
      .subscribe();
  }

  closeTab(){
    window.close()
  }

  confirmPaymentRequest(paymentReferenceNo: Required<string>, token) {
    return this._service.ca_confirmPaymentRequest(paymentReferenceNo, token)
      .pipe(
        tap((res) =>this.message = "TopUp successfully completed"),
        catchError((e:HttpErrorResponse) => {
          this.message = "Top Up failed";
          if (e.error) {
            this.message = e.error.error.message
          }
          // this.router.navigate(['../../../'], { relativeTo: this.activateRoute, replaceUrl: true, queryParams: { error: errorMessage } });
          return EMPTY;
        })
        )
      }
    }
